<div class="actionset-separator" *ngIf="getIndexByModel() > 0"><hr></div>
<div  *ngIf="getIndexByModel() == 0">
    <span class="actionset-title">{{getActionSetTitle()}}</span>
    <hr>
</div>
